@for (part of parts; track part.$id) {
	@if (!part.highlighted) {{{ part.text }}}
	@if (part.highlighted) {<span class="highlight">{{ part.text }}</span>}
}
